module.exports = __webpack_public_path__ + "static/media/p3.62eb2969.jpg";